module.exports = __webpack_public_path__ + "static/media/soils_reports_6.7f470873.png";


//////////////////
// WEBPACK FOOTER
// ./public/stem_soils_images/soils_reports_6.png
// module id = 1293
// module chunks = 0